"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const OfferWithEstimatesPackage_1 = tslib_1.__importDefault(require("./OfferWithEstimatesPackage"));
class GetOfferWithEstimatesResponseV2 extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => OfferWithEstimatesPackage_1.default),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Array)
], GetOfferWithEstimatesResponseV2.prototype, "packages", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.Docs)({
        example: [
            'Unknown error when calling AoM for offer 009c65d9-d0ba-437f-a9d8-dde6c36811a2/143276: Record not found in PropositionInfo For Postal Code : 4214EC HouseNo : 21 HouseNoExtension : ',
        ],
        description: 'Any non-fatal errors thrown, such as an offer being filtered out because AoM did not have tariffs/rates for it. These can be used for debugging purposes.',
    }),
    tslib_1.__metadata("design:type", Array)
], GetOfferWithEstimatesResponseV2.prototype, "errorMessages", void 0);
exports.default = GetOfferWithEstimatesResponseV2;
